import React from 'react';

import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';
import ErrorMessage from 'ui-library/ErrorMessage';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import TextField from 'ui-library/inputs/TextField';

import {CustomTransform} from '../../RunSchemaSpecConstants';
import {CustomTransformFormErrors, updateTransformationProperties} from './TransformFormUtils';

interface CustomTransformFormProps {
  transform: CustomTransform;
  disabled?: boolean;
  onChange: (transform: CustomTransform) => void;
  formErrors: CustomTransformFormErrors;
}

export default function CustomTransformForm(props: CustomTransformFormProps): JSX.Element {
  return (
    <Row>
      <Col md={6}>
        <TextField
          label="Benchling App ID"
          onChange={(e) => {
            props.onChange(updateTransformationProperties(props.transform, 'transformId', e.target.value));
          }}
          labelStyle={FieldLabel.STYLES.LABEL}
          isRequired={true}
          value={props.transform.transformationProperties.transformId}
          hasError={props.formErrors.transformId}
        />
        {props.formErrors.transformId ? <ErrorMessage error="Benchling App ID is required" /> : null}
      </Col>
    </Row>
  );
}
